/* eslint react/prop-types: 0 */
import React from 'react';
import { formatPhoneNumber } from '../../../Forms/yup/customValidations';

function DataPhone({ value }) {
  return <span className="numbers">{formatPhoneNumber(value)}</span>;
}

export default DataPhone;
